import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("cc_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("cc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang];
      for (const p of parts) {
        if (cur == null) return path;
        cur = cur[p];
      }
      return cur ?? path;
    },
    [lang]
  );

  const pick = useCallback(
    (obj, field) => {
      if (!obj) return "";
      return obj[`${field}_${lang}`] ?? obj[`${field}_en`] ?? "";
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t, pick }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
